// README: this is to keep scroll tracked, you should reorder this
// array if you reorder the jsx.
export const SECTIONS = [
  'section-hero',
  'section-courses',
  'section-packs',
  'section-membership',
  'section-microdegree',
  'section-bottom-banner',
  'section-footer',
];
